// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';
import { type TabBarNavigationType } from '../../types/tabBar';
import NavigationTabBarItemContainer from '../NavigationTabBarItem/NavigationTabBarItemContainer';

const TabBarWrapper = styled.div`
  width: 100%;

  background: ${theme.TabBar.backgroundColor};

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

  -webkit-tap-highlight-color: transparent;
  z-index: ${theme.ZIndices.tabBar};
`;

const StyledTabBarItemContainer = styled(NavigationTabBarItemContainer)`
  flex: 1;
`;

type PropsType = {
  itemIds: Array<TabBarNavigationType>;
  className?: string;
};

const NavigationTabBar = (props: PropsType) => {
  const { itemIds, className } = props;

  if (itemIds?.length) {
    return (
      <TabBarWrapper className={className}>
        {itemIds.map((id) => (
          <StyledTabBarItemContainer key={`tab-bar-item-${id}`} id={id} />
        ))}
      </TabBarWrapper>
    );
  }

  return null;
};

export default NavigationTabBar;
